// Need to use the React-specific entry point to allow generating React hooks
import {
    BaseQueryFn,
    createApi,
    FetchArgs,
    fetchBaseQuery,
    FetchBaseQueryError,
    FetchBaseQueryMeta
} from '@reduxjs/toolkit/query/react'
import {RootState} from "../../store";
import {FetchBaseQueryArgs} from "@reduxjs/toolkit/dist/query/fetchBaseQuery";
import {logout, updateTokens, UpdateTokensPayload} from "../authentication/authentication-slice";
import {API_URL} from "../../config";

const baseAuthenticatedQueryParams: FetchBaseQueryArgs = {
    baseUrl: (API_URL ?? '') + '/',
    prepareHeaders: (headers, { getState }) => {
        //headers.set("x-api-key", KEY)
        const token = (getState() as RootState).authentication.accessToken;

        if (token) {
            headers.set("authorization", `Bearer ${token}`);
            headers.set("Accept", `application/json`);
            headers.set("content-type", `application/json`);
        }

        return headers;
    }
};

const baseAuthenticatedQuery = fetchBaseQuery(baseAuthenticatedQueryParams);

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, object, FetchBaseQueryMeta> = async (args, api, extraOptions) => {
    let result = await baseAuthenticatedQuery(args, api, extraOptions)

    if (result?.error?.status === 401) {
        // send refresh token to get new access token

        const refreshResult = await fetchBaseQuery({
            ...baseAuthenticatedQueryParams,
            method: "POST",
            body: JSON.stringify({ refreshToken: (api.getState() as RootState).authentication.refreshToken })
        })('/user/refresh', api, extraOptions);

        if (refreshResult?.data) {
            // store the new tokens
            api.dispatch(updateTokens({ ...(refreshResult.data as UpdateTokensPayload)}));
            // retry the original query with new access token
            result = await baseAuthenticatedQuery(args, api, extraOptions);
        } else {
            api.dispatch(logout())
        }
    }

    return result
}

// Define a service using a base URL and expected endpoints
export const apiSlice = createApi({

    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: (API_URL ?? '') + '/',
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            // Bearer token from login, so auth also works when the browser blocks the
            // cross-site session cookie (the API is on a different host than the client).
            const token = (getState() as RootState).authentication.accessToken;
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            //headers.set("x-api-key", KEY)
            // headers.set("Access-Control-Allow-Origin", `http://localhost:3001/`);
            // headers.set("Referrer Policy", "no-referrer");
            return headers;
        }
    }),
    // baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
    }),
})
